import { bandFor, percentOfPlan, type Band, type ProductionBands } from '@siteday/shared';

export { bandFor, percentOfPlan };
export type { Band };

/** Icon glyph + label that reads without color (doc 08 W2: "color is never the only signal"). */
export function bandGlyph(band: Band): string {
  switch (band) {
    case 'green':
      return '●';
    case 'amber':
      return '▲';
    case 'red':
      return '✕';
    default:
      return '';
  }
}

/** Text shown inside a band pill: "▲ 90%" or a fallback such as "no entry". */
export function bandLabel(band: Band, pct: number | null, fallback = 'no entry'): string {
  if (band === 'none' || pct === null) return fallback;
  return `${bandGlyph(band)} ${pct}%`;
}

/** Band from actual/plan strings with tenant thresholds. */
export function bandForActual(
  actual: string | number | null | undefined,
  plan: string | number | null | undefined,
  bands?: ProductionBands,
): { pct: number | null; band: Band } {
  if (actual === null || actual === undefined || actual === '') return { pct: null, band: 'none' };
  const pct = percentOfPlan(actual, plan);
  return { pct, band: bandFor(pct, bands) };
}

/** Sort weight so red sorts first when a table is sorted by band. */
export function bandWeight(band: Band): number {
  return { red: 0, amber: 1, green: 2, none: 3 }[band];
}
